import { type ReactNode, useEffect, useRef } from "react"

/**
 * Content that unfolds below the fold should bring itself into view once,
 * so the click that revealed it is visibly answered. No-op where the
 * platform lacks scrollIntoView (test DOMs).
 */
export function RevealOnMount({ className, children, ...rest }: { className?: string; children: ReactNode; [key: `data-${string}`]: string }) {
    const ref = useRef<HTMLDivElement | null>(null)
    useEffect(() => {
        const element = ref.current
        if (element && typeof element.scrollIntoView === "function") element.scrollIntoView({ block: "nearest", behavior: "smooth" })
    }, [])
    return (
        <div ref={ref} className={className} {...rest}>
            {children}
        </div>
    )
}
